import { enableSpinner, disableSpinner } from '@js/utilities/spinner';
import { mountProductBadges } from '../../../vue/helpers/badgesMount';

const fetchProductsList = async (showPage) => {
    // console.log(window.getProductsQueryString);

    const url = new URLSearchParams(window.getProductsQueryString);

    url.set('page', showPage);

    const urlString = decodeURIComponent(url.toString());

    const response = await fetch(urlString);

    const html = await response.text();

    const div = document.createElement('div');

    div.innerHTML = html;

    const productItemElements = [...div.querySelectorAll('.js-product-item')].reduce(
        (acc, current) => `${acc}${current.outerHTML}`,
        ''
    );

    return productItemElements;
};

export const ProductsListPaginatorController = () => {
    const productsListElement = document.querySelector('.js-products-list');
    // const productsListContainer = document.querySelector('.js-products-list-content-container');
    const loadNextProductsContainer = document.querySelector('.js-load-next-products-container');
    const loadPreviousProductsContainer = document.querySelector(
        '.js-load-previous-products-container'
    );

    const state = {
        products_count: window.productsListInitials.products_count,
        products_per_page: window.productsListInitials.products_per_page,
        products_total_pages: window.productsListInitials.products_total_pages,
        products_current_page: window.productsListInitials.products_current_page,
        showing_pages_from: window.productsListInitials.products_current_page,
        showing_pages_to: window.productsListInitials.products_current_page,
    };

    const loadNextElement = document.querySelector('.js-load-next-products');
    const loadPreviousElement = document.querySelector('.js-load-previous-products');

    const urlController = () => {
        const url = new URLSearchParams(window.location.search);

        url.set('page', state.products_current_page);

        if (state.products_current_page === 1) {
            url.delete('page');
        }

        const urlString = decodeURIComponent(url.toString());

        window.history.pushState(
            {},
            '',
            `${window.location.pathname}${urlString ? `?${urlString}` : ''}`
        );
    };

    const buttonsVisibilityController = () => {
        if (state.showing_pages_from > 1) {
            loadPreviousProductsContainer.classList.remove('d-none');
        } else {
            loadPreviousProductsContainer.classList.add('d-none');
        }

        if (state.showing_pages_to < state.products_total_pages) {
            loadNextProductsContainer.classList.remove('d-none');
        } else {
            loadNextProductsContainer.classList.add('d-none');
        }
    };

    loadPreviousElement?.addEventListener('click', async () => {
        enableSpinner(loadPreviousElement);

        state.products_current_page -= 1;
        state.showing_pages_from -= 1;

        const html = await fetchProductsList(state.products_current_page);

        productsListElement.insertAdjacentHTML('afterbegin', html);

        window.dispatchEvent(
            new CustomEvent('products-list-loaded', {
                detail: state,
            })
        );

        window.dispatchEvent(new Event('RemoteContentLoaded'));

        buttonsVisibilityController();
        urlController();

        disableSpinner(loadPreviousElement);
    });

    loadNextElement?.addEventListener('click', async () => {
        enableSpinner(loadNextElement);

        state.products_current_page += 1;
        state.showing_pages_to += 1;

        const html = await fetchProductsList(state.products_current_page);

        productsListElement.insertAdjacentHTML('beforeend', html);

        await mountProductBadges(productsListElement);
        window.fetchBadges(window.collectIds(productsListElement));

        window.dispatchEvent(
            new CustomEvent('products-list-loaded', {
                detail: state,
            })
        );

        window.dispatchEvent(new Event('RemoteContentLoaded'));

        buttonsVisibilityController();
        urlController();

        disableSpinner(loadNextElement);
    });

    buttonsVisibilityController();
};
